import { defineAsyncComponent } from "vue";
const FilePickerVue = defineAsyncComponent(() => import("./FilePicker-ajWx2Snh.mjs"));
export {
  FilePickerVue
};
